import api from './api';

export const shippingService = {
  getProviders: async () => {
    const response = await api.get('/shipping/providers');
    return response.data;
  },

  getShippingRate: async (provider, pincode) => {
    const response = await api.get('/shipping/rates', {
      params: { provider, pincode }
    });
    return response.data;
  },

  getRatesForAllProviders: async (providers, pincode) => {
    const results = {};
    const promises = providers.map(async (p) => {
      try {
        const response = await api.get('/shipping/rates', {
          params: { provider: p.code, pincode }
        });
        results[p.code] = response.data.data;
      } catch (err) {
        results[p.code] = {
          providerCode: p.code,
          providerName: p.name,
          serviceable: false,
          error: err.response?.data?.message || 'Failed to get rates'
        };
      }
    });
    await Promise.all(promises);
    return results;
  }
};
